import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { OroService } from '../oroservice';
@Injectable({
    providedIn: 'root'
})
export class AuthMasterGuard  {
    constructor(private oroService: OroService, private router: Router) { };
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        console.log('CanActivate called (Master)');

        if (this.oroService.IsLoggedIn) {
            if (this.oroService.kundeninfo && this.oroService.kundeninfo.IsMaster) {
                return true;
            } else {
                console.log(" -> Startseite");
                this.router.navigate(['/Startseite']);
            }
        } else {
            console.log(" -> login");
            this.router.navigate(['/login']);
        }
    }
}